export default __webpack_public_path__ + "static/media/voting.7701d66d.png";